import React from 'react';
import {
	AppBar, Toolbar, ButtonBase, InputBase, Icon, List, ListItem,
	ListItemText, Popover, Typography, ListItemIcon, IconButton,
	Drawer
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { withRouter } from 'react-router-dom';

//icons svg
import IconRelogio from '../../../images/svg/relogio.svg';

import Logo from "../../../images/logo.png";

import './header.css';

const menus = [
	{
		nome: 'Inicio',
		url: '/inicio',
	},
	{
		nome: 'O Shopping',
		url: '/o-shopping',
	},
	{
		nome: 'Lojas',
		url: '/lojas',
	},
	{
		nome: 'Cinema',
		url: 'https://www.cinea.com.br/VTO',
		external: true,
	},
	{
		nome: 'Serviços',
		url: '/servicos',
	},
	{
		nome: 'Eventos',
		url: '/eventos',
	},
	{
		nome: 'Fale Conosco',
		url: '/fale-conosco',
	}
]

class HeaderApp extends React.Component {
	state = {
		anchorEl: null,
		menu: false,
		search: false,

		busca: '',
	}

	handleSearch = (event) => {
		const { busca } = this.state;
		const { history } = this.props;
		const { submitSearch } = this.props;
		event.preventDefault();
		history.push('/busca?s=' + busca);
		submitSearch(busca);
	}

	render() {
		const { anchorEl, menu, search, busca } = this.state;
		const { func_seg_sab_loja, func_seg_sab_lazer, func_domingo_loja, func_domingo_lazer } = this.props.informacoes;
		const dia = moment().format('dddd');
		return (
			<AppBar color="default" className="header_webapp" >
				<div className="header_webapp__container" >
					<Toolbar className="header_webapp__menu" >
						<div className="menu__container" >
							<div className="header_webapp__logo" >
								<img src={Logo} alt="Logo Shopping Norte Sul" />
							</div>
							<ul className="header_webapp__menulist" >
								{menus.map((m, k) => {
									if (m.external) {
										return (
											<li key={k} >
												<ButtonBase focusRipple
													component="a"
													target="_blank"
													href={m.url} >
													{m.nome}
												</ButtonBase>
											</li>
										)
									}
									return (
										<li key={k} >
											<ButtonBase focusRipple
												component={Link}
												to={m.url} >
												{m.nome}
											</ButtonBase>
										</li>
									)
								})}
							</ul>
							<div className="header_webapp__menu_responsive" >
								<IconButton onClick={() => this.setState({ search: !search })} >
									<Icon>search</Icon>
								</IconButton>
								<IconButton onClick={() => this.setState({ menu: true })} >
									<Icon>menu</Icon>
								</IconButton>
							</div>
						</div>
					</Toolbar>
					<Toolbar className={`header_webapp__menu_secondary ${search ? 'open_search' : ''}`} >
						<div className="header_webapp__search" >
							<form onSubmit={this.handleSearch} >
								<div className="search__icon" >
									<Icon>search</Icon>
								</div>
								<InputBase fullWidth
									value={busca}
									onChange={e => this.setState({ busca: e.target.value })}
									placeholder="Busque por lojas, restaurantes, produtos e serviços.." />
							</form>
						</div>
						<div className="header_webapp__actionbuttons" >
							{/* <ButtonBase focusRipple
										component={Link}
										to="/pet-friendly" >
									<img src={IconPet} alt="pet" />
									Pet Friendly
							</ButtonBase>
							<ButtonBase focusRipple
										component={Link} to="/lojista" >
									<img src={IconLojista} alt="Lojista" />
									Area do Lojista
							</ButtonBase> */}
							<ButtonBase focusRipple
								className="drop"
								onClick={(e) => this.setState({ anchorEl: e.currentTarget })}
								aria-controls="horario_drop"
								aria-haspopup="true"
							>
								<img src={IconRelogio} alt="Funcionamento" />
								<div>
									Hoje - Aberto das {dia !== 'Domingo' ? func_seg_sab_loja : func_domingo_loja}
									<p>VER HORARIO DE FUNCIONAMENTO</p>
								</div>
								<Icon>arrow_drop_down</Icon>
							</ButtonBase>
							<Popover
								id="horario_drop"
								anchorEl={anchorEl}
								open={Boolean(anchorEl)}
								onClose={() => this.setState({ anchorEl: null })}
								anchorOrigin={{
									vertical: 'bottom',
									horizontal: 'center',
								}}
								transformOrigin={{
									vertical: 'top',
									horizontal: 'center',
								}}
							>
								<List>
									<ListItem>
										<ListItemIcon>
											<Icon>access_time</Icon>
										</ListItemIcon>
										<ListItemText primary="Segunda a Sábado" secondary={
											<React.Fragment>
												<Typography component="span" variant="body2">
													Lojas: {func_seg_sab_loja}
												</Typography>
												<Typography component="span" variant="body2">
													Alimentação: {func_seg_sab_lazer}
												</Typography>
											</React.Fragment>
										} />
									</ListItem>
									<ListItem>
										<ListItemIcon>
											<Icon>access_time</Icon>
										</ListItemIcon>
										<ListItemText primary="Domingo e Feriados" secondary={
											<React.Fragment>
												<Typography component="span" variant="body2">
													Lojas: {func_domingo_loja}
												</Typography>
												<Typography component="span" variant="body2">
													Alimentação: {func_domingo_lazer}
												</Typography>
											</React.Fragment>
										} />
									</ListItem>
								</List>
							</Popover>
						</div>
					</Toolbar>
				</div>
				<Drawer anchor="right" className="drawer_menu" open={menu} onClose={() => this.setState({ menu: false })}>
					<List className="drawer_menu__list" >
						{menus.map((m, k) => {
							if (m.external) {
								return (
									<ListItem
										key={k}
										onClick={() => this.setState({ menu: false })}
										href={m.url}
										button
										component="a"
										target="_blank"
									>
										<ListItemText primary={m.nome} />
									</ListItem>
								);
							}
							return (
								<ListItem
									key={k}
									onClick={() => this.setState({ menu: false })}
									component={Link}
									to={m.url}
									button>
									<ListItemText primary={m.nome} />
								</ListItem>
							);
						})}
						{/* <ListItem onClick={() => this.setState({ menu:false })}
								  component={Link}
								  to="#"
								  button >
							<ListItemText primary="Pet Friendly" />
						</ListItem>
						<ListItem onClick={() => this.setState({ menu:false })}
								  component={Link}
								  to="#"
								  button >
							<ListItemText primary="Area do lojista" />
						</ListItem> */}
					</List>
				</Drawer>
			</AppBar>
		);
	}
}

export default withRouter(HeaderApp);



// WEBPACK FOOTER //
// ./src/web/components/HeaderApp/index.js